import { Box, Divider, SxProps, Theme } from "@mui/material";
import { Children, cloneElement, isValidElement, ReactNode } from "react";

interface FormGridProps {
    children: ReactNode;
    columns?: number | { xs?: number; sm?: number; md?: number; lg?: number };
    gap?: number;
    showDivider?: boolean;
    sx?: SxProps<Theme>;
    childrenStyle?: Record<string, any>;
}

const FormGrid = ({ children, columns = 2, gap = 2, showDivider = false, sx, childrenStyle }: FormGridProps) => {
    // Handle both simple number and responsive object
    const gridColumns =
        typeof columns === "number"
            ? `repeat(${columns}, minmax(0, 1fr))`
            : {
                  xs: columns.xs ? `repeat(${columns.xs}, minmax(0, 1fr))` : "1fr",
                  sm: columns.sm ? `repeat(${columns.sm}, minmax(0, 1fr))` : undefined,
                  md: columns.md ? `repeat(${columns.md}, minmax(0, 1fr))` : undefined,
                  lg: columns.lg ? `repeat(${columns.lg}, minmax(0, 1fr))` : undefined,
              };

    return (
        <>
            {showDivider && <Divider sx={{ my: 1 }} />}
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: gridColumns,
                    alignItems: "center",
                    gap,
                    ...sx,
                }}
            >
                {childrenStyle
                    ? Children.map(children, (child) =>
                        isValidElement<{ sx?: SxProps<Theme> }>(child)
                            ? cloneElement(child, {
                                sx: { ...childrenStyle, ...child.props.sx },
                            })
                            : child,
                      )
                    : children}
            </Box>
        </>
    );
};

export default FormGrid;
